"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyManager = void 0;
var JourneyManager = /** @class */ (function () {
    function JourneyManager(journey) {
        this.journey = journey;
    }
    JourneyManager.prototype.fetchEntryPage = function () {
        return this.fetchPage(this.journey.entryPage);
    };
    JourneyManager.prototype.fetchPage = function (pageId) {
        for (var _i = 0, _a = this.journey.pages; _i < _a.length; _i++) {
            var page = _a[_i];
            if (page.pageId === pageId) {
                return page;
            }
        }
        return undefined;
    };
    return JourneyManager;
}());
exports.JourneyManager = JourneyManager;
//# sourceMappingURL=JourneyManager.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/services/JourneyManager.js
// module id = 1020
// module chunks = 0